'use client';

import { type ChatQualifyCopy } from './chat-copy';
import { ChatPhone } from './chat-phone';

/**
 * Domain 3 / hero keystone — WhatsApp qualifying, shown as a realistic phone
 * (see chat-phone.tsx). The conversation is an EXAMPLE BUSINESS qualifying its
 * own lead (a solar installer asking the real qualifiers: home ownership +
 * power bill), localized per page locale so the agent speaks the lead's
 * language. Not Selenos qualifying anyone. Copy is built by buildChatCopy in
 * the plain chat-copy module (callable from server or client).
 */
export function ChatQualifyAnimation({
  copy,
  className,
}: {
  copy: ChatQualifyCopy;
  className?: string;
}) {
  return (
    <ChatPhone
      className={className}
      copy={{
        business: copy.business,
        status: copy.status,
        typing: copy.typing,
        qualified: copy.qualified,
        example: copy.example,
        inputPlaceholder: copy.inputPlaceholder,
        messages: [
          { dir: 'in', text: copy.m1 },
          { dir: 'out', text: copy.m2 },
          { dir: 'in', text: copy.m3 },
          { dir: 'out', text: copy.m4 },
          { dir: 'in', text: copy.m5 },
        ],
      }}
    />
  );
}
